import { productCountStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductCount";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

productCountStyles.wrapper = {
    css: css`
        span {
            font-style: normal;
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.small};
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            color: ${getColor("text.main")};
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 8px;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
